
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Tracking label='content50' mdxType="Tracking" />
    <p>{`Ja, sagte der britische Physiker Stephen Hawking in Bezug auf sein Fach
Astronomie vor seinem Tod im vergangenen Jahr: «Wir standen dicht vor einer
vollständigen Theorie, die das Universum in allem, was es enthielt, beschreiben
würde.»`}</p>
    <p>{`Ungeklärt ist aus naturwissenschaftlicher Sicht vorab noch eine Frage: Wenn beim
Urknall Materie und Antimaterie zusammenstiessen und sich die Energie danach in
Raum und Zeit ausdehnte, war etwas da vorher oder war nichts? Wenn etwas da war,
müsste erklärt werden können, wie es entstanden war. Wenn nichts da war, wie
Materie und Antimaterie überhaupt zusammenstossen konnten. Einig sind sich die
Physiker einzig darin, dass es sehr klein war, was da war, vielleicht sogar nur
die Grösse eines Protons hatte.`}</p>
    <p>{`Für die Sozial- und Geisteswissenschaften bleibt das Rätsel, auch dann, wenn aus
naturwissenschaftlicher Sicht alle Rätsel gelöst sind: Wie kann der Mensch einen
leer geräumten Himmel aushalten? Die allumfassende Entzauberung von Welt und
Mensch führt zu einer nüchternen, trostlosen Existenz und der Perspektive des
absoluten Nichts nach dem Tod. Gibt es eine Form von Transzendenz der
menschlichen Existenz ohne Hokuspokus und Aberglaube.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;